<template>
    <b-modal scrollable b-modal title="Parametri Vitali" ref="mdlParametriVitali" id="mdlParametriVitali" size="xl" @ok="onSalva" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label>Parametro Vitale</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.descrizioneMisurazione" class="mb-2 mr-sm-2 mb-sm-0" :options="parametriVitaaliOptions" :value="''" value-field="value" text-field="text" @change="onChangeParametroVitale" :disabled="jsonData.id !== null && jsonData.id !== ''"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaParametriVitaliValori" :fields="fields" :current-page="1" :per-page="500000" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(measurename)="item">
                            <span> {{ getLabelTraduora(item.item.measurename) }} </span>
                        </template>
                        <template #cell(value)="item">
                            <b-form-input v-model="item.item.value"></b-form-input>
                        </template>
                    </b-table>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <b-form-textarea v-model="jsonData.note"></b-form-textarea>
                    </b-col>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {},
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            listKey: 0,
            pathResourceParamentriVitali: "/rsaconfigurazioneparametrivitali",
            pathResource: "/rsaparametrivitalitestate",
            id: null,
            parametriVitaaliOptions: [{ value: null, text: "-Seleziona Valore-" }],
            jsonData: { id: null, idAccettazione: "", descrizioneMisurazione: "", note: null, listaParametriVitaliValori: [] },
            filtro: {},
            fields: [
                { label: "Misura", key: "measurename" },
                { label: "Valore", key: "value", thStyle: "width: 20rem" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
    },
    watch: {},
    methods: {
        show(id) {
            let me = this;
            me.loadParametriVitali();
            me.id = id;
            if (id === null) {
                me.jsonData = { id: null, idAccettazione: "", descrizioneMisurazione: "", note: null, listaParametriVitaliValori: [] };
            } else {
                me.loadData();
            }
            me.$refs.mdlParametriVitali.show();
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(link, null, me.resultResponse, me.resutlError);
        },
        resultResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.listKey++;
        },
        resutlError(error) {
            console.log(error);
        },
        loadParametriVitali() {
            let me = this;
            me.parametriVitaaliOptions = [];
            UtilityMixin.methods.loadDataResources(me.pathResourceParamentriVitali, {}, me.resultResponseParametriVitali, me.resutlErrorParametriVitali);
        },
        resultResponseParametriVitali(response) {
            let me = this;

            response.data.data.list.forEach((element) => {
                me.parametriVitaaliOptions.push({ value: element.descrizione, text: element.descrizione });
            });
            me.parametriVitaaliOptions.unshift({ value: "", text: "-Seleziona Valore-" });
        },
        resutlErrorParametriVitali(error) {
            let me = this;
            console.log(error);
            me.parametriVitaaliOptions.unshift({ value: "", text: "-Seleziona Valore-" });
        },
        onChangeParametroVitale() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceParamentriVitali + "/parametro/" + me.jsonData.descrizioneMisurazione;
            UtilityMixin.methods.restCallGet(link, null, me.resultResponseParametriVitaliDettagi, me.resutlErrorParametriVitaliDettagi);
        },
        resultResponseParametriVitaliDettagi(response) {
            let me = this;
            let parametro = response.data.data;
            parametro.listaMisurazioni.forEach((element) => {
                me.jsonData.listaParametriVitaliValori.push({ measurename: element.misura, value: null });
            });
            me.listKey++;
        },
        resutlErrorParametriVitaliDettagi(error) {
            console.log(error);
        },
        close() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlParametriVitali.hide();
        },
        onSalva(bvModalEvent) {
            let me = this;
            me.jsonData.idAccettazione = me.idAccettazione;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultResponseSave, me.resultErrorSave);
            bvModalEvent.preventDefault();
        },
        resultResponseSave() {
            let me = this;
            me.$refs.mdlParametriVitali.hide();
            me.$emit("saveSuccess");
        },
        resultErrorSave(error) {
            UtilityMixin.methods.messaggeBoxError(this, error);
        },
    },
};
</script>
